// generated by genversion
export var version = '4.7.0';
//# sourceMappingURL=version.js.map